import m3 from "../../assets/imgs/veiculos/m3.png";
import z4 from "../../assets/imgs/veiculos/z4.png";
import m5 from "../../assets/imgs/veiculos/m5.png";
import serie3 from "../../assets/imgs/veiculos/serie-3.png";
import serie4 from "../../assets/imgs/veiculos/serie-4.png";
import serie1 from "../../assets/imgs/veiculos/serie1.png";
import serie2 from "../../assets/imgs/veiculos/serie2.png";
import x2 from "../../assets/imgs/veiculos/x2.png";

export const carsData = [
	{ name: "BMW Série 1", img: serie1, type: "1" },
	{ name: "BMW M3 Competition", img: m3, type: "M3" },
	{ name: "BMW M5", img: m5, type: "M5" },
	{ name: "BMW X2", img: x2, type: "X2" },
	{ name: "BMW Série 4", img: serie4, type: "4" },
	{ name: "BMW Série 3", img: serie3, type: "3" },
	{ name: "BMW Z4", img: z4, type: "Z4" },
	{ name: "BMW Série 2", img: serie2, type: "2" },
];
